import $ from 'jquery'
import Modal from 'bootstrap/js/src/modal'
import Behaviors from './../behaviors'

export default class openAjaxModal {
    constructor (element) {
        this.$element = $(element)
        this.modalUrl = this.$element.data('modalUrl')
        this.loadingText = this.$element.data('modalLoadingText')
        this.loadInProgress = false
        this.modalIdSuffix = Math.random().toString(16).slice(2)
        this.loadingModal = null

        this.$element.on('click.openAjaxModal', this.handleClick.bind(this))
    }

    handleClick (event) {
        event.preventDefault()
        this.loadContent()
    }

    createLoadingModal () {
        const $modal = this.createIntermediateModal('loading', '', `
            <div class="loadingSpinner d-flex flex-column justify-content-center align-items-center py-5">
                <div>${this.loadingText}</div>
                <div class="spinnerContainer">
                    <i class="fa-solid fa-spinner fa-spin"></i>
                </div>
            </div>`)
        $modal.prependTo($('body'))
        this.loadingModal = Modal.getOrCreateInstance($modal.get(0), { backdrop: 'static', keyboard: false })
    }

    getLoadingModal () {
        if (this.loadingModal) {
            return this.loadingModal
        }
        this.createLoadingModal()
        return this.loadingModal
    }

    hideLoadingModal () {
        this.loadingModal.hide()
        this.removeLoadingModal()
    }
    removeLoadingModal () {
        this.loadingModal._element.remove()
    }

    createErrorModal () {
        const $modal = this.createIntermediateModal('error', '', '<p>Ein Fehler ist aufgetreten</p>')
        $modal.prependTo($('body'))
        this.errorModal = Modal.getOrCreateInstance($modal.get(0), { })
    }

    createIntermediateModal (id, classes, modalContent) {
        const template = `
            <div class="modal ${classes}" id="${id}${this.modalIdSuffix}">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-body">
                        ${modalContent}
                  </div>
                </div>
              </div>
            </div>`
        return $(template)
    }

    removeModal () {
        if (this.modal) {
            this.modal.hide()
            this.modal.dispose()
            this.modal = null
        }

        if (this.$modal && this.$modal.length > 0) {
            this.$modal.remove()
        }

        if (this.$modalWrapper && this.$modalWrapper.length > 0) {
            this.$modalWrapper.remove()
        }
    }

    handleBeforeCloseModal () {
        this.removeFocusFromModal()
    }

    handleCloseModal () {
        this.removeModal()
        this.focusModalToggle()
    }

    loadContent () {
        if (this.loadInProgress) {
            return
        }

        this.removeModal()

        this.loadInProgress = true
        this.getLoadingModal().show()
        window.setTimeout(() => { this.hideLoadingModal() }, 2000)

        $.get(this.modalUrl, function (data, xhr, status) { })
            .done(function (data) {
                this.hideLoadingModal()
                this.loadInProgress = false

                this.$modalWrapper = $('<div></div>').html(data)
                this.$modalWrapper.appendTo($('body'))

                this.$modal = this.$modalWrapper.find('.modal:first')
                this.$modal.get(0).addEventListener('hide.bs.modal', this.handleBeforeCloseModal.bind(this))
                this.$modal.get(0).addEventListener('hidden.bs.modal', this.handleCloseModal.bind(this))

                this.modal = Modal.getOrCreateInstance(this.$modal.get(0), {
                    keyboard: true,
                    focus: true
                })

                this.modal.show()

                this.$buttons = this.$modal.find('.modal-footer [type=button]')
                this.$buttons.on('click', this.handleModalButtonClick.bind(this))

                Behaviors.attachBehaviors(this.$modal.parent().get(0))

                this.loadInProgress = false
            }.bind(this))
            .fail(function () {
                this.createErrorModal()
                this.errorModal.show()
                window.setTimeout(() => { this.errorModal.hide() }, 10000)
            }.bind(this))
            .always(function () {
                this.hideLoadingModal()
                this.loadInProgress = false
            }.bind(this))
    }

    handleModalButtonClick (event) {
        event.preventDefault()
        const $target = $(event.target)
        const action = $target.data('action')
        switch (action) {
            case 'submit:last':
                const $formLast = this.$modal.find('form:last')
                $formLast.trigger('submit')
                break
            case 'submit:first':
            case 'submit':
                const $formFirst = this.$modal.find('form:first')
                $formFirst.trigger('submit')
                break
        }
    }

    removeFocusFromModal () {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur()
        }
    }
    focusModalToggle () {
        this.$element.focus()
    }

    destroy () {
        this.$element.off('click.openAjaxModal')
    }
}
